var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('change-logs-filters',{model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('change-logs-list',{attrs:{"filter":_vm.query},model:{value:(_vm.customer.change_logs),callback:function ($$v) {_vm.$set(_vm.customer, "change_logs", $$v)},expression:"customer.change_logs"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }